import Page from '@/components/Page.vue';

import {
  createRouter,
  createWebHistory,
} from 'vue-router';

const routes = [
  {
    path: '/',
    component: Page,
  },
  {
    path: '/:pageSlug',
    component: Page,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
